import { render } from "./ProductDetail_GovernmentInfoCollection.vue?vue&type=template&id=6fdc1dcf&scoped=true"
import script from "./ProductDetail_GovernmentInfoCollection.vue?vue&type=script&lang=js"
export * from "./ProductDetail_GovernmentInfoCollection.vue?vue&type=script&lang=js"

import "./ProductDetail_GovernmentInfoCollection.vue?vue&type=style&index=0&id=6fdc1dcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdc1dcf"]])

export default __exports__